/* eslint-disable */
import BASE from '../../../../vue.config.js'
import Vue from 'vue/dist/vue.js'

const $ = require('jquery')

export default {
	data() {
		return{
			icon:"pdf.png",
			// pdfUrl:"http://www.psicologia.unam.mx/documentos/pdf/Licenciatura_Psicologia_UNAM_Plan_de_Estudios_2008_Informacion_y_estructura.pdf",
			pdfUrl:"",
			misAsignaturas:[],
			temarioPopup:false,
			selectedAsignatura:null,
			errorFileType: false,
			uploadPdfPopup: false,
  	  isTemarioPreCharged: false,

			temario:{
  	  	chargedDoc: {
  	  		isCharged: false,
					name: '',
					file: null,
					eventTarget: null,
					fileLink: ''
  	  	}
  	  },

  	  // Upload files button states
		 	uploadFileCharged:{
		 		onProgress: false,
		 		readyProgess: false,
		 		fileError: null,
		 		text: 'cloud_upload',
		 		style:{
		 			height: null
		 		}
		 	}
		}
	},
	methods: {
		successUpload() {
			this.$vs.notify({ color: 'success', title: 'Upload Success', text: 'Lorem ipsum dolor sit amet, consectetur' })
		},
		getActionIconsStyle(asignatura){
			console.log(asignatura);
			if (asignatura.temarioPlantel != '' && asignatura.temarioProfesor != '') {
				return 'w-1/3';
			}else if(asignatura.temarioPlantel != '' || asignatura.temarioProfesor != ''){
				return 'w-1/2';
			}else{
				return 'w-full';
			}
		},
		getMisAsignaturas(){
			this.misAsignaturas = [];
			fetch(`${BASE.baseUrl}api/MisAsignaturas`, {
				method: 'GET',
				headers: {
					'Authorization': sessionStorage.getItem('token'),
					'pagina':'listadoMaterias'
				}
			})
			.then(rs => rs.json())
			.catch(error => console.log('error:', error))
			.then(rs => {
				console.log(JSON.stringify(rs));
				if(rs.status == 200){
					rs.result.misAsignaturas.forEach(asignatura=>{
						if(asignatura.temarioProfesor != ''){
							asignatura.temarioProfesor = `${BASE.baseUrl}${asignatura.temarioProfesor}`;
						}
						if(asignatura.temarioPlantel != ''){
							asignatura.temarioPlantel = `${BASE.baseUrl}${asignatura.temarioPlantel}`;
						}
						// console.log(asignatura.nombre)
						// console.log(asignatura.temarioProfesor);
						this.misAsignaturas.push(asignatura)
					})
				}
			});
		},
		openTemarioPopup(pdfUrl){
			this.pdfUrl = pdfUrl;
			this.temarioPopup = true;
		},
		openUploadPdfPopup(asignatura){
			if (this.temario.chargedDoc.isCharged) {
				this.deleteChargedFile(this.temario);
			}
			this.uploadPdfPopup = true;
			this.selectedAsignatura = asignatura;
		},
		onDocChargeChanged($event){
			this.errorFileType = false;
			let fileType = event.target.files[0].type
			if (fileType == 'application/pdf') {
				this.selectedFile = event.target.files[0]
				this.temario.chargedDoc.isCharged = true;
				this.temario.chargedDoc.name = this.selectedFile.name;
				this.temario.chargedDoc.file = this.selectedFile;
				this.temario.chargedDoc.eventTarget = event.target;
				this.temario.uploadFile = this.uploadFileCharged;
				var read = new FileReader();
				read.onload = (e) => {
					this.temario.chargedDoc.filesrc = e.target.result;
				}
				read.readAsDataURL(this.temario.chargedDoc.file);
				this.contieneDocumento = 1;
				console.log(JSON.stringify(this.temario));
			}else{
 				this.errorFileMsg = 'Solo se permiten tipos de archivo PDF.'
				this.errorFileType = true;
			}
		},
		deleteChargedFile(documento){
			console.log(JSON.stringify(documento));
			console.log('*** deleteChargedFile ***');
			// Se borra el archivo cargado
			documento.chargedDoc.file = null;
			documento.chargedDoc.isCharged = false;
			documento.chargedDoc.name = '';
			documento.uploadFile = this.uploadFileCharged;

			if (!this.isTemarioPreCharged) {
				// Como no se pueden borrar los objetos de un Filelist
				// se convierte el input a 'text' y se regresa a 'file'
				// de esta manera se borra el archivo que se cargó
				// el evento onDocChargeChanged ya hace efecto si se borra el archivo cargado
				// y se vuelve a subir el mismo archivo
				documento.chargedDoc.eventTarget.type = 'text';
				documento.chargedDoc.eventTarget.type = 'file';
			}
			this.isTemarioPreCharged = false;
			this.contieneDocumento = 0;
 		},
 		downloadTemarioGeneral(temarioPlantel){
      this.$_downloadFileMixin_donwloadFile(temarioPlantel);
 			
 		},
 		sendTemario(){
 			if (this.temario.chargedDoc.file != null) {
 				let vm = this;
 				if (this.selectedAsignatura.temarioProfesor != '') {
 					console.log('editarDocumento');
 					let objetoAsignatura ={
	 					idAsignatura:this.selectedAsignatura.idAsignatura,
	 					contieneDocumento: 1,
	 					idDetalleDocumento: this.selectedAsignatura.idDetalleDocumento
	 				}
	 				console.log(JSON.stringify(objetoAsignatura))
	 				const formData = new FormData();
	 				formData.append('objeto', JSON.stringify(objetoAsignatura));
	 				formData.append('archivo', this.temario.chargedDoc.file);
					 console.log('PRUEBA',JSON.stringify(this.temario.chargedDoc.file));
 					$.ajax({
						url: `${BASE.baseUrl}api/EditarDocumento`,
						headers:{
							'Authorization': sessionStorage.getItem('token')
						},
						type:'POST',
						dataType:'json',
						cache: false,
						contentType: false,
						processData: false,
						data:formData,
						success: function(rs){
							console.log(rs)
							if (rs.status === 200) {
								vm.showNotify(rs.status, null, 'La síntesis se subió satisfactoriamente.');
								vm.uploadPdfPopup = false;
								vm.getMisAsignaturas();
		 					}else{
								vm.showNotify(rs.status);
								vm.uploadPdfPopup = false;
								vm.getMisAsignaturas();
		 					}
						},
						error: function (xhr, ajaxOptions, thrownError) {
							console.log('error')
							console.log(xhr.status);
							console.log(thrownError);
						}
					});
 				}else{
 					console.log('agregarDocumento')
	 				let objetoAsignatura ={
	 					idAsignatura:this.selectedAsignatura.idAsignatura
	 				}
	 				const formData = new FormData();
	 				formData.append('objeto', JSON.stringify(objetoAsignatura));
	 				formData.append('archivo', this.temario.chargedDoc.file);

	 				$.ajax({
						url: `${BASE.baseUrl}api/AgregarDocumento`,
						headers:{
							'Authorization': sessionStorage.getItem('token')
						},
						type:'POST',
						dataType:'json',
						cache: false,
						contentType: false,
						processData: false,
						data:formData,
						success: function(rs){
							// console.log(rs)
							if (rs.status === 200) {
								vm.showNotify(rs.status, null, 'La síntesis se subió satisfactoriamente.');
								vm.uploadPdfPopup = false;
								vm.getMisAsignaturas();
		 					}else{
								vm.showNotify(rs.status);
								vm.uploadPdfPopup = false;
								vm.getMisAsignaturas();
		 					}
						},
						error: function (xhr, ajaxOptions, thrownError) {
							console.log('error')
							console.log(xhr.status);
							console.log(thrownError);
						}
					});
 				}
 			}else{
 				this.errorFileMsg = 'Debes cargar la síntesis para enviarla.'
 				this.errorFileType = true;
 			}
 		}
	},
	created(){
		this.getMisAsignaturas();
	}
}
